import React, { Component } from "react";
import "./index.css";
import { connect } from "../../utils";
import YoutubePreview from "./YoutubePreview";
class YoutubeView extends Component {
  render() {
    const { id, layoutState } = this.props;
    const { containerPadding, alignValue, videoId } = layoutState.getItemJS(
      id
    ).props.values;

    return (
      <div
        style={{
          boxSizing: "border-box",
          position: "relative",
          height: "100%",
          display: "flex",
          padding: containerPadding,
          flex: 1,
          justifyContent: alignValue
        }}
      >
        <YoutubePreview videoId={videoId} />
      </div>
    );
  }
}
export default connect("layoutState")(YoutubeView);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/YoutubeView.js